import { computed, reactive, readonly, toRefs } from 'vue';
import { saveExtraData, saveOrderDataApi } from '@/api';
import { orderHash } from '@/stores/Order';
import { setGlobalMessage } from '@/stores/Global';

const state = reactive({
  fields: {}
});

export const userDetailValues = readonly(toRefs(state).fields);

export function setUserDetailValue(key, value) {
  state.fields[key] = value;
}

export function setUserDetailValues(obj) {
  state.fields = obj;
}

export const paymentType = computed(() => {
  return state.fields['payment_type'] || null;
});

export async function saveUserDetails() {
  let paymentType = null;
  const collect = {};

  for (const [key, value] of Object.entries(state.fields)) {
    if (key === 'payment_type') {
      paymentType = value;
    } else {
      collect[key] = value;
    }
  }

  const { success: orderDataSuccess, message: orderMessage } =
    await saveOrderDataApi(orderHash.value, 'payment_type', paymentType);

  const { success: extraDataSuccess, message: extraDataMessage } =
    await saveExtraData(orderHash.value, collect);

  if (
    !orderDataSuccess ||
    (!extraDataSuccess && (orderMessage || extraDataMessage))
  ) {
    setGlobalMessage(orderMessage || extraDataMessage);
  }

  return {
    success: orderDataSuccess && extraDataSuccess
  };
}
